import { QueryElementType } from '../../types';
import { parseExpression } from '../../utils';

/**
 * Helper function to parse text and determine suggestion context
 */
export function determineSuggestionContext(
  text: string,
  previousType: QueryElementType | null,
): {
  context: string | null;
  field?: string | null;
  inputText: string;
  operator?: string | null;
  prefixOperator?: string | null;
} {
  try {
    const parsed = parseExpression(text);
    const [
      [prefixOperatorStr, fieldStr, opStr, _valueStr],
      {
        complete: _complete,
        context,
        contextInput,
        identifierLocation: _identifierLocation,
        operatorLocation: _operatorLocation,
        valueLocation: _valueLocation,
      },
    ] = parsed;

    const isTypingField = context === 'field' || context === 'prefix-operator';
    const isTypingOperator = context === 'operator';
    const isTypingValue = context === 'value';

    if (isTypingField) {
      return [null, 'text', 'logical-operator', 'grouping-operator-opener'].includes(previousType)
        ? {
            context: 'field',
            field: null,
            inputText: fieldStr?.replace(prefixOperatorStr ?? '', '') || '',
            operator: null,
            prefixOperator: prefixOperatorStr,
          }
        : {
            context: 'logical-operator',
            field: null,
            inputText: fieldStr?.replace(prefixOperatorStr ?? '', '') || '',
            operator: null,
            prefixOperator: prefixOperatorStr,
          };
    } else if (isTypingOperator) {
      return {
        context: 'operator',
        field: fieldStr?.trim(),
        inputText: opStr || '',
        operator: null,
        prefixOperator: prefixOperatorStr,
      };
    } else if (isTypingValue) {
      return {
        context: 'value',
        field: fieldStr?.trim(),
        inputText: contextInput.trim(),
        operator: opStr?.trim(),
        prefixOperator: prefixOperatorStr,
      };
    }

    return { context: null, field: null, inputText: '', operator: null, prefixOperator: null };
  } catch {
    return { context: null, field: null, inputText: '', operator: null, prefixOperator: null };
  }
}
